import styled from "@emotion/styled";
import React from "react";

interface ProductStatusDropdownProps {
  selectedStatuses: string[];
  setSelectedStatuses: React.Dispatch<React.SetStateAction<string[]>>;
}

const ProductStautsDropdown: React.FC<ProductStatusDropdownProps> = ({
  selectedStatuses,
  setSelectedStatuses,
}) => {
  const handleToggle = (values: string | string[]) => {
    const valueArray = Array.isArray(values) ? values : [values];
    setSelectedStatuses((prev) => {
      const newSet = new Set(prev);

      const allSelected = valueArray.every((val) => newSet.has(val));
      if (allSelected) {
        valueArray.forEach((val) => newSet.delete(val));
      } else {
        valueArray.forEach((val) => newSet.add(val));
      }

      return Array.from(newSet);
    });
  };

  return (
    <>
      <ButtonGroup>
        <StyledButton
          isSelected={selectedStatuses.includes("TEMP")}
          onClick={() => handleToggle("TEMP")}>
          임시저장
        </StyledButton>

        <StyledButton
          isSelected={selectedStatuses.includes("STOCK")}
          onClick={() => handleToggle("STOCK")}>
          재고
        </StyledButton>

        <StyledButton
          isSelected={selectedStatuses.includes("SALE")}
          onClick={() => handleToggle("SALE")}>
          판매
        </StyledButton>
      </ButtonGroup>
    </>
  );
};

export default ProductStautsDropdown;

const ButtonGroup = styled.div({
  display: "flex",
  gap: "1.2rem",
  width: "100%",
  justifyContent: "space-between",
  marginTop: "1rem",
});

const StyledButton = styled.button<{ isSelected: boolean }>(
  ({ theme, isSelected }) => ({
    fontSize: "1.6rem",
    width: "100%",
    border: `1px solid ${isSelected ? theme.color.mint : theme.color.light_gray}`,
    color: isSelected ? theme.color.black : theme.color.light_gray,
    backgroundColor: isSelected ? theme.color.light_mint : "white",
    borderRadius: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: "1.6rem",
    transition: "all 0.2s",
    "&:hover": {
      borderColor: theme.color.mint,
      color: theme.color.black,
    },
  }),
);
